<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="164" height="110" viewBox="0 0 164 110" fill="#517B86">
        <path d="M0 110C4.4994 90.8345 17.1062 75.473 33.2787 69.4579C49.4512 63.4429 68.8408 66.9029 84.462 78.5913C86.737 55.8729 96.0759 35.144 110.436 20.9703C124.792 6.79451 144.061 -0.729068 164 0.0557808V110H0Z" />
    </svg>
</template>

<script>
export default {
    name: "ShapeTeaser"
}
</script>